import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCenterArticlesBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterArticles/ArticlesBody/HealthCenterArticlesBody";

const HealthCenterArticles = () => {
  useEffect(() => {
    document.title = "Articles";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCenterArticlesBody />
    </main>
  );
};

export default HealthCenterArticles;
